import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
const transport = axios.create({
    baseURL: 'https://www.mathfabpm.com',
    withCredentials: true
    });
// const host = 'http://127.0.0.1:8000/';
// const host = 'https://www.mathfabpm.com/';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        loggedIn: JSON.parse(localStorage.getItem('loggedIn')) || false,
        currentUser: {
            'pk': null,
            'first_name': null,
            'last_name': null,
        },
        project_manager_list: [],
        job_list: [],
        journal: [],
        team_list: [],
    },
    getters: {
        loggedIn(state) {
            return state.loggedIn
        },
        current_user(state) {
            return state.currentUser
        },
        job_list(state) {
            return state.job_list
        },
        journal(state){
            return state.journal
        },
        project_manager_list(state) {
            return state.project_manager_list
        },
        team_list(state) {
            return state.team_list
        },
    },
    mutations: {
        set_current_user(state, data) {
            state.currentUser.pk = data.pk;
            state.currentUser.first_name = data.first_name;
            state.currentUser.last_name = data.last_name;
        },
        set_logged_in(state, status) {
            state.loggedIn = status
        },
        set_job_list(state, job_list) {
            state.job_list = job_list
        },
        set_journal_list(state, journal) {
            this.state.journal = journal
        },
        set_project_manager_list(state, pm_list) {
            this.state.project_manager_list = pm_list
        },
        set_team_list(state, team_list) {
            state.team_list = team_list
        }
    },
    actions: {

        // Auth
        obtainToken(context, credentials) {

            // Get Bearer token from API (stored as HttpOnly Secure Cookie
            return new Promise((resolve, reject) => {
                transport.post('/api/get-token/',
                    {
                        username: credentials.username,
                        password: credentials.password,
                    }).then((response) => {

                        // set logged in status
                        context.commit('set_logged_in', true);
                        localStorage.setItem('loggedIn', JSON.stringify(true));

                        resolve(response)
                }).catch(error => {
                        // eslint-disable-next-line no-console
                        console.log(error);
                        reject(error)
                })
            })
        },
        removeToken(context) {
            return new Promise(((resolve, reject) => {
                transport.post(
                    '/api/remove-token/',
                    {}
                    ).then((respose) => {

                    context.commit('set_logged_in', false);
                    localStorage.removeItem('loggedIn');

                    resolve(respose)
                }).catch(e => {
                    reject(e)
                })
            }))
        },
        refreshToken(context) {
            return new Promise(((resolve, reject) => {
                transport.post(
                    '/api/refresh-token/'
                ).then(response => {
                    resolve(response)
                }).catch(e => {
                    context.commit('set_logged_in', false);
                    reject(e)
                })
            }))
        },
        tryRefresh(context, payload) {
            /*
            Takes a Vuex Action and tries to complete it.
            If it fails, it tries to refresh authentication, then attempts the action again
             */
            return new Promise(((resolve, reject) => {
                if(payload.data === null) {
                    context.dispatch(payload.action).then((response) => {
                        resolve(response)
                    }).catch(e => {

                        if(e.response.status === 401){
                            context.dispatch('refreshToken').then(() => {
                                context.dispatch(payload.action).then((response) => {
                                    resolve(response)
                                }).catch(e => {
                                    // eslint-disable-next-line no-console
                                    console.log('Refresh Succeeded, Action: ' + payload.action + ' still failed' + e.response.statusText);
                                    // eslint-disable-next-line no-console
                                    console.log(e);
                                    reject(e)
                                })
                            }).catch(e => {
                                this.$store.dispatch('removeToken');
                                this.$router.push({name: 'login'});
                                // eslint-disable-next-line no-console
                                console.log('Refresh Failed: ' + e.response.statusText);
                                // eslint-disable-next-line no-console
                                console.log(e);
                                reject(e);
                            })
                        } else {
                            // eslint-disable-next-line no-console
                            console.log('Action ' + payload.action + ' failed: ' + e.response.statusText);
                            // eslint-disable-next-line no-console
                            console.log(e)
                        }

                    })
                } else {
                    context.dispatch(payload.action, payload.data).then((response) => {
                        resolve(response)
                    }).catch(e => {

                        if(e.response.status === 401){
                            context.dispatch('refreshToken').then(() => {
                                context.dispatch(payload.action, payload.data).then((response) => {
                                    resolve(response)
                                }).catch(e => {
                                    // eslint-disable-next-line no-console
                                    console.log('Refresh Succeeded, Action: ' + payload.action + ' still failed' + e.response.statusText);
                                    // eslint-disable-next-line no-console
                                    console.log(e);
                                    reject(e)
                                })
                            }).catch(e => {
                                this.$store.dispatch('removeToken');
                                this.$router.push({name: 'login'});
                                // eslint-disable-next-line no-console
                                console.log('Refresh Failed: ' + e.response.statusText);
                                // eslint-disable-next-line no-console
                                console.log(e);
                                reject(e);
                            })
                        } else {
                            // eslint-disable-next-line no-console
                            console.log('Action ' + payload.action + ' failed: ' + e.response.statusText);
                            // eslint-disable-next-line no-console
                            console.log(e);
                            reject(e)
                        }

                    })
                }
            }));

        },

        // App general
        obtainUserDetails(context) {

            return new Promise((resolve, reject) => {
                transport.get('/api/user/').then(response  => {

                    context.commit('set_current_user', {
                        'id': response.data[0].pk,
                        'first_name': response.data[0].first_name,
                        'last_name': response.data[0].last_name,
                    });

                    resolve(response)
                }).catch((error) => {
                    reject(error);
                })


            });
        },
        obtainProjectManagerList(context) {
            return new Promise(((resolve, reject) => {
                transport.get(
                    '/api/project-manager-list/',
                ).then(response => {
                    context.commit('set_project_manager_list', response.data);
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            }))
        },
        obtainTeamList(context){
            return new Promise(((resolve, reject) => {
                transport.get(
                    '/api/team-list/',
                ).then(response => {
                    context.commit('set_team_list', response.data);
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            }))
        },

        // App Jobs
        obtainJobList(context) {
            return new Promise(((resolve, reject) => {
                transport.get(
                    '/jobs/api/list/'
                ).then((response) => {
                    context.commit('set_job_list', response.data);
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            }))
        },
        submitNewJob(context, data) {

            return new Promise((resolve, reject) => {
                transport.post(
                    '/jobs/api/list/',
                    data
                ).then((response) => {
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            })

        },
        submitJobEdit(context, data) {
            return new Promise((resolve, reject) => {
                transport.put(
                    '/jobs/api/' + data.number,
                    data
                ).then((response) => {
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            })
        },

        // App Journal
        obtainJournal(context) {
            return new Promise((resolve, reject) => {
                transport.get(
                    '/journal/api/list/',
                ).then(response => {
                    context.commit('set_journal_list', response.data);
                    resolve(response)
                }).catch(e => {
                    reject(e)
                })
            })
        },
    }
});